import React, { useState } from "react";
import { useSelector } from "react-redux";
import { onKeyDown } from "../../../service";
import classes from './ContentBankPopup.module.css'
import ContentBankWrapper from "./ContentBankWrapper";

const ContentBankPopup = ({ type, selectOnClick, closeOnClick }) => {

    const { texts } = useSelector(state => state.translate);

    const [material, setMaterial] = useState({ id: null, name: null, createdDate: null, thumbnail: null })

    return (
        <div className={classes.StudyLibaryPopupWrapper} >
            <div className={classes.StudyLibaryPopup} >
                <div className={classes.HeaderPopup}></div>
                <div className={classes.ClosePopup} onClick={closeOnClick} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, closeOnClick)}></div>
                <div className={classes.MateriallsLibary} >
                    <ContentBankWrapper
                        fromPopup={type}
                        selectedMaterial={material.id}
                        setSelectedMaterial={(e) => setMaterial({ ...e, id: e.id, name: e.name, createdDate: e.createdDate, thumbnail: e.thumbnail })}
                    />
                    <div className={classes.MaterialBtns}>
                        <button className={classes.AddMaterial} disabled={!material?.id} onClick={() => selectOnClick(material)}>{texts.add}</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default ContentBankPopup